import { render, staticRenderFns } from "./Conference.html?vue&type=template&id=bbc57380&scoped=true&"
import script from "./Conference.js?vue&type=script&lang=js&"
export * from "./Conference.js?vue&type=script&lang=js&"
import style0 from "./Conference.scss?vue&type=style&index=0&id=bbc57380&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc57380",
  null
  
)

export default component.exports